import { ISystemResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export type SystemsFilter = Readonly<{
    locationId: string | undefined;
    nameSearch?: string;
    isCollectorDependentSystem?: boolean;
}>;

export type SystemsDataSourceOptions = BaseDataSourceOptions<
    ISystemResponse,
    SystemsFilter
>;

const queryFn: DataSourceQuery<ISystemResponse, SystemsFilter> = ({
    filter: { locationId, nameSearch, isCollectorDependentSystem },
    sort,
    page,
    pageLimit,
}) => {
    const filter = Filter.and(
        locationId && Filter.eq('LocationId', locationId),
        isCollectorDependentSystem !== undefined
            ? Filter.eq('IsCollectorDependentSystem', isCollectorDependentSystem)
            : undefined,
    );

    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getSystems({ filter, page, pageLimit, orderBy, nameSearch }),
    );
};

export type SystemsPagedDataSource = PagedDataSource<ISystemResponse, SystemsFilter>;

export type SystemsInfiniteDataSource = InfiniteDataSource<
    ISystemResponse,
    SystemsFilter
>;

export function useSystemsPagedDataSource(
    options: SystemsDataSourceOptions,
): SystemsPagedDataSource {
    return usePagedDataSource({
        ...options,
        query: queryFn,
    });
}

export function useSystemsInfiniteDataSource(
    options: SystemsDataSourceOptions,
): SystemsInfiniteDataSource {
    return useInfiniteDataSource({
        ...options,
        query: queryFn,
    });
}
